<template>
  <div class="aside-card">
    <el-dropdown trigger="click" placement="bottom" popper-class="aside-type-dropdown">
      <div class="company">
        <!-- <el-avatar shape="circle" :size="35" :src="teamDefaultImage" /> -->
        <div class="companyData">
          <div class="tag" v-if="currentCompany.isUpdateAuth">
            <img src="@/assets/images/common/company_BGZ.png" alt="企业认证状态" />
          </div>
          <div class="tag" v-else-if="currentCompany.isCompanyAuth">
            <img
              v-if="currentCompany.isCompanyAuth !== 'WRZ'"
              :src="require(`@/assets/images/common/company_${currentCompany.isCompanyAuth}.png`)"
              alt="企业认证状态"
            />
          </div>
          <div class="companyName">
            {{ currentCompany.companyName || "未知" }}
          </div>
        </div>
        <svg viewBox="0 0 16 24" height="16" stroke="currentColor" fill="none" stroke-width="1.5">
          <path d="M13 8.517L8 3 3 8.517M3 15.48l5 5.517 5-5.517"></path>
        </svg>
      </div>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item
            class="dropdown-items items"
            v-for="item in companyData"
            :key="item.value"
            :class="{ active: currentCompany.companyId === item.value }"
            :disabled="item.isExamine"
            @click="handleChange(item.value, item.isExamine)"
          >
            <el-tooltip class="box-item" effect="dark" :content="item.label" placement="right">
              <div class="company-info-box">
                <span class="label"> {{ item.label }}</span>
                <el-tag type="warning" size="mini" v-if="item.isExamine"> 审核中 </el-tag>
                <img
                  v-if="item.isCompanyAuth !== 'WRZ'"
                  :src="require(`@/assets/images/common/company_icon_${item.isCompanyAuth}.png`)"
                  alt="企业认证状态"
                />
              </div>
            </el-tooltip>
          </el-dropdown-item>

          <!-- <el-dropdown-item class="dropdown-items" divided @click="onCreateCompany">创建/加入企业</el-dropdown-item> -->
          <!-- <el-dropdown-item class="dropdown-items" @click="onJoinCompany">加入企业</el-dropdown-item> -->
          <!-- <el-dropdown-item class="dropdown-items" divided @click="onChange">切换至个人版</el-dropdown-item> -->
        </el-dropdown-menu>
      </template>
    </el-dropdown>
    <el-dialog v-model="centerDialog" title="" width="30%" destroy-on-close :close-on-click-modal="false" @close="closeLessionChange()">
      <div class="dialogData">
        <div class="title">申请已提交，请等待审核！</div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closeLessionChange()">关闭</el-button>
          <el-button @click="revocation" :loading="loading" type="primary">撤销</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import teamDefaultImage from "@/assets/images/common/team.png";
import { creatLogo } from "@/utils";
import { ref, computed } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { userRevokeExamine } from "@/http/api/workbench";
import { ElMessage } from "element-plus";
import _ from "lodash";
let store = useStore();
let router = useRouter();
let route = useRoute();

let centerDialog = ref(false);
let loading = ref(false);
let comId = ref("");
let authState = ref("");
let authChangeState = ref("");
let companyData = computed(() => {
  return store.getters["auth/sortCompany"];
});
let currentCompany = computed(() => {
  return store.getters["auth/currentCompany"];
});
const companyAvatar = computed(() => {
  if (currentCompany.value.companyId != -1) {
    store.dispatch("auth/acquirekCompany");
  }
  return creatLogo(store.getters["auth/currentCompany"].companyName || "管管安全") || "";
});

const handleChange = (e, isExamine) => {
  if (isExamine) {
    open(e);
    return;
  }
  store.commit("auth/setCurrentCompany", e);
  store.dispatch("auth/getRoleList");
  store.dispatch("auth/acquirekCompany");
  store.dispatch("auth/getMenuRole");
  //主账号提醒判断，是否是要提醒的机构且第一次提醒后不在提醒
  let { companyId, flag } = store.state.auth.adminAccountAlert;
  if (companyId === e && flag) {
    store.commit("auth/adminAccountMessageAlert");
    store.commit("auth/setAdminAccountAlert", { companyId, flag: false });
  }
  if (route.path === "/homePage") {
    return;
  }
  router.push("/homePage");
};

const onChange = async () => {
  await router.push("/homePage");
  await store.commit("auth/setCurrentCompany", "-1");
  await store.dispatch("auth/getRoleList");
  await store.dispatch("auth/acquirekCompany");
  await store.dispatch("auth/getMenuRole");
};
//开启
const open = (e) => {
  comId.value = e;
  centerDialog.value = true;
};
//关闭
const closeLessionChange = () => {
  centerDialog.value = false;
};
//撤销
const revocation = async () => {
  loading.value = true;
  try {
    await userRevokeExamine({ comId: comId.value });
    loading.value = false;
    ElMessage.success("撤销成功");
    await store.dispatch("auth/getUserInfoNoMessage");
    await store.dispatch("auth/getCompanyList");
    closeLessionChange();
    onChangeHolder();
    goBack();
  } catch (error) {
    loading.value = false;
  }
};
//关闭
const goBack = () => {
  router.push({
    path: "/homePage"
  });
};
const onCreateCompany = () => router.push("/createCompany");
const onJoinCompany = () => router.push("/joinCompany");
</script>

<style lang="scss" scoped>
.aside-card {
  user-select: none;
  position: relative;
  height: fit-content;
  margin-right: 60px;
  display: flex;
  justify-content: center;
  background-color: #ffffff;
  ::v-deep(.el-avatar) {
    background: #fff;
  }
    &::after {
      display: block;
      content: '';
      height: 20px;
      width: 0;
      position: absolute;
      top: calc(50% - 10px);
      right: -30px;
      border: 1px solid #eaeaea;
    }
  header {
    .text {
      color: #adb5bd;
      font-weight: bold;
      font-size: 16px;
      text-align: left;
    }
  }
  .company {
    cursor: pointer;
    display: flex;
    align-items: center;
    ::v-deep(.el-avatar) {
      --el-avatar-background-color: #fff !important;
    }
    .companyData {
      flex: 1;
      display: inline-flex;
      align-items: center;
      .companyName {
        max-width: 150px;
        margin: 0 10px;
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: 24px;
        line-height: 24px;
      }
      .tag {
        margin-right: 10px;
        & > img {
          width: 74px;
          height: 30px;
          overflow: hidden;
        }
      }
    }
  }
  .checkCompany {
    position: absolute;
    left: 286px;
    top: 40px;
    background: #f9f9f9;
    border: solid 1px #dcdfe6;
    z-index: 9;
    border-radius: 8px;
    .company_list {
      max-height: 550px;
      margin: 10px;
      .items {
        cursor: pointer;
        padding: 5px 0;
      }
      .content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0 10px 0;
        .optionName {
          width: 200px;
          display: block;
          font-size: 16px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .checkin {
          float: right;
          .default {
            margin-left: 5px;
          }
        }
      }
    }
    .onePeople {
      text-align: center;
      border-top: solid 1px #dcdfe6;
      padding: 5px;
    }
  }
}
// .label {
//   cursor: pointer;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   width: 100%;
//   font-size: 16px;
//   color: #666;
//   &.start {
//     justify-content: flex-start;
//   }
// }
.dropdown-items {
  width: 220px;
  padding: 0 30px;
  line-height: 50px;

  &.items {
    .company-info-box {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .label {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      & > img {
        width: 25px;
        height: 27px;
        overflow: hidden;
      }
    }
  }
  &.active {
    font-weight: bold;
    color: #ff6a00;
  }
  &:hover {
    color: #ff6a00 !important;
  }
}
.dialogData {
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    font-size: 26px;
  }
}
.el-dropdown-menu {
  max-height: 750px;
}
.divider {
      color: #eaeaea;
    }
</style>
